import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BranchAndDepartmentService {

  constructor(private http: HttpClient, private httpService: HttpService) { }


  /**
   * Get Branch List
   * @returns array
   */
  getBranch() {
    var headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.set("x-access-token", token)
    return this.http.get(environment.pssServerUrl + 'brnch/master'  + "/" + token, { headers: headers })
      .map(res => res);
  }


  /**
   * Get Branch List
   * @returns array
   */
  deleteBranch(id) {
    var headers = new Headers();
    headers.set('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.set("x-access-token", token)
    return this.http.post(environment.PSSFileNotValidurl + 'brnch/master/delete/' + id, { headers: headers })
      .map((res) => res);
  }

  deleteDepartment(id) {
    var headers = new Headers();
    headers.set('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.set("x-access-token", token)
    return this.http.post(environment.PSSFileNotValidurl + 'department/master/delete/' + id, { headers: headers })
      .map((res) => res);
  }

  update(id, data) {
    var headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.set("x-access-token", token)
    return this.http.post(environment.PSSFileNotValidurl + 'department/master/put/' + id, data, { headers: headers })
      .map((res) => res);
  }

  updateBranch(id, data) {
    var headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.set("x-access-token", token)
    return this.http.post(environment.PSSFileNotValidurl + 'brnch/master/put/' + id, data, { headers: headers })
      .map(res => res);
  }

  /**
   * Get Department List
   * @returns array
   */
  getDepartment() {
    var headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.set("x-access-token", token)
    return this.http.get(environment.pssServerUrl + 'department/master' + "/" + token, { headers: headers })
      .map(res => res);
  }

  checkDepartment(data) {
    var headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.set("x-access-token", token)
    return this.http.post(environment.PSSFileNotValidurl + 'department/master/check/exist', data, { headers: headers })
      .map((res) => res);
  }

  checkBranch(data) {
    var headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.set("x-access-token", token)
    return this.http.post(environment.PSSFileNotValidurl + 'brnch/master/check/exist', data, { headers: headers })
      .map((res) => res);
  }

  /**
   * Add Branch master
   * @param data 
   * @returns 
   */

  addBranch(data) {
    const token = localStorage.getItem('token');
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': token || ''
    });
  
    return this.http.post(environment.PSSFileNotValidurl + 'brnch/master', data, { headers })
      .pipe(map(res => res));
  }

  /**
   * Add Department Data
   * @param data 
   * @returns 
   */

  addDepartment(data) {
    const token = localStorage.getItem('token') || '';
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': token
    });
  
    return this.http.post(environment.PSSFileNotValidurl + 'department/master', data, { headers })
      .pipe(map(res => res));
  }
}


